import React from 'react';
import { rem } from 'polished';
import { Link } from 'react-router-dom';
import '../css/elements/logo.css';
import { Flex, Box } from 'components/grid';
// import { Text } from 'components/typography';

const LogoContainer = () => (
  <Link to="/" className="logo">
    <Flex justifyContent="center" alignItems="center">
      <Box mr={rem(10)}>
        <img
          src="/assets/images/tp-logo-alternative.svg"
          width="200"
          height="50"
          alt="TeaPayment"
        />
      </Box>
      {/*<Text fw="700">Operations</Text>*/}
    </Flex>
  </Link>
);
export default LogoContainer;
